"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var emitSocketEvent = function emitSocketEvent(socket, eventName, data) {
  socket.emit(eventName, data);
};
var _default = exports["default"] = emitSocketEvent;